@if (goldenHandle) {
  <div class="modal fade show golden-handle-backdrop" role="dialog" [ngStyle]="{ display: 'block' }" (click)="close()">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div #modalScroller class="modal-content profile-modal" (scroll)="onModalScroll($event)">
        <header class="profile-topbar">
          <div class="topbar-title">
            <strong>{{ goldenHandle.meta_data?.name || goldenHandle.name }}</strong>
            <span>{{ compactNumber(goldenHandle.meta_data?.statusesCount) }} posts</span>
          </div>
          <a class="icon-button" [href]="goldenHandle.xUrl" target="_blank" rel="noopener noreferrer" title="Open on X"><i class="las la-external-link-alt"></i></a>
          <button class="icon-button" type="button" aria-label="Close" (click)="close()"><i class="las la-times"></i></button>
        </header>
        <div class="profile-cover" [style.background-image]="goldenHandle.meta_data?.coverPicture ? 'url(' + goldenHandle.meta_data.coverPicture + ')' : null"></div>
        <section class="profile-summary">
          <img class="profile-avatar" [src]="highResolutionProfilePicture(goldenHandle.meta_data?.profilePicture) || profilePlaceholder" [alt]="goldenHandle.name + ' profile picture'" (error)="onProfileImageError($event)" />
          <h4>
            {{ goldenHandle.meta_data?.name || goldenHandle.name }}
            @if (goldenHandle.meta_data?.isBlueVerified || goldenHandle.meta_data?.isVerified) { <i class="las la-check-circle verified" aria-label="Verified"></i> }
          </h4>
          <a [href]="goldenHandle.xUrl" target="_blank" rel="noopener noreferrer">&#64;{{ goldenHandle.meta_data?.userName || goldenHandle.xHandle }}</a>
          @if (goldenHandle.meta_data?.description) { <p>{{ goldenHandle.meta_data.description }}</p> }
          <div class="profile-facts">
            @if (goldenHandle.meta_data?.location) { <span><i class="las la-map-marker"></i>{{ goldenHandle.meta_data.location }}</span> }
            @if (profileWebsite(goldenHandle.meta_data)) { <a [href]="profileWebsite(goldenHandle.meta_data)" target="_blank" rel="noopener noreferrer"><i class="las la-link"></i>{{ profileWebsite(goldenHandle.meta_data) }}</a> }
            @if (goldenHandle.meta_data?.createdAt) { <span><i class="las la-calendar"></i>Joined {{ goldenHandle.meta_data.createdAt | date: "MMM yyyy" }}</span> }
          </div>
          <div class="profile-stats">
            <span><strong>{{ compactNumber(goldenHandle.meta_data?.following) }}</strong> Following</span>
            <span><strong>{{ compactNumber(goldenHandle.meta_data?.followers) }}</strong> Followers</span>
          </div>
        </section>
        <div class="profile-tabs"><span>Posts</span></div>
        <div class="post-list">
          @if (loading) {
            <div class="post-state">Loading posts...</div>
          } @else {
            @for (post of posts; track post._id) {
              <article class="post">
                <img class="post-avatar" [src]="post.author?.profilePicture || goldenHandle.meta_data?.profilePicture || profilePlaceholder" [alt]="goldenHandle.name + ' profile picture'" (error)="onProfileImageError($event)" />
                <div class="post-content">
                  <div class="post-heading"><strong>{{ post.author?.name || goldenHandle.name }}</strong><span>&#64;{{ post.author?.userName || goldenHandle.xHandle }}</span><span>·</span><span>{{ post.publishedAt | date: "MMM d, y" }}</span></div>
                  <p class="post-text" [attr.data-post-text-key]="post._id" [class.expanded]="expandedPostText.has(post._id)">{{ post.text }}</p>
                  @if (isPostTextTruncated(post._id)) { <button class="view-more" type="button" (click)="togglePostText(post._id)">{{ expandedPostText.has(post._id) ? "View less" : "View more" }}</button> }
                  @if (post.media?.length) {
                    <div class="post-media" [class.multiple]="post.media.length > 1">
                      @for (media of post.media; track media.imageUrl) {
                        @if (media.videoUrl) { <video controls preload="metadata" [poster]="media.imageUrl"><source [src]="media.videoUrl" type="video/mp4" /></video> }
                        @else { <img [src]="media.imageUrl" alt="Post media" loading="lazy" /> }
                      }
                    </div>
                  }
                  @if (post.embeddedPost) {
                    <div class="embedded-post">
                      <small>{{ post.embeddedPostType }}</small>
                      <div class="embedded-heading"><strong>{{ post.embeddedPost.author?.name }}</strong><span>&#64;{{ post.embeddedPost.author?.userName }}</span></div>
                      <p>{{ post.embeddedPost.text }}</p>
                      @if (post.embeddedPost.media?.length) {
                        <div class="post-media" [class.multiple]="post.embeddedPost.media.length > 1">
                          @for (media of post.embeddedPost.media; track media.imageUrl) {
                            @if (media.videoUrl) { <video controls preload="metadata" [poster]="media.imageUrl"><source [src]="media.videoUrl" type="video/mp4" /></video> }
                            @else { <img [src]="media.imageUrl" alt="Embedded post media" loading="lazy" /> }
                          }
                        </div>
                      }
                    </div>
                  }
                  <div class="post-metrics">
                    <span><i class="las la-comment"></i>{{ compactNumber(post.metrics?.replies) }}</span>
                    <span><i class="las la-retweet"></i>{{ compactNumber(post.metrics?.reposts) }}</span>
                    <span><i class="lar la-heart"></i>{{ compactNumber(post.metrics?.likes) }}</span>
                    <span><i class="las la-eye"></i>{{ compactNumber(post.metrics?.views) }}</span>
                    <a [href]="post.url" target="_blank" rel="noopener noreferrer"><i class="las la-external-link-alt"></i></a>
                  </div>
                </div>
              </article>
            }
            @if (!posts.length) { <div class="post-state">No collected posts found.</div> }
            @if (loadingMore) { <div class="post-state loading-more">Loading more posts...</div> }
          }
        </div>
      </div>
      @if (showScrollToTop) {
        <button class="scroll-to-top" type="button" aria-label="Scroll to top" title="Scroll to top" (click)="scrollToTop(modalScroller)">
          <i class="las la-arrow-up"></i>
        </button>
      }
    </div>
  </div>
}
